import React from 'react'
import styles from './shared-skeleton.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'
import { Table, TableRow, HeadCell } from 'pobble-components/dist/table'
import SharedSkeletonEntry from './shared-skeleton-entry/shared-skeleton-entry'

const SharedSkeleton = ({ classes }) => (
  <div className={classes.container}>
    <Table className={classes.table}>
      <thead>
        <TableRow>
          <HeadCell className={classes.allCell}>
            <Bone className={classes.all} />
          </HeadCell>
          <HeadCell className={classes.receivedCell}>
            <Bone className={classes.received} />
          </HeadCell>
          <HeadCell className={classes.fromCell}>
            <Bone className={classes.from} />
          </HeadCell>
          <HeadCell className={classes.titleCell}>
            <Bone className={classes.title} />
          </HeadCell>
          <HeadCell className={classes.loCell}>
            <Bone className={classes.lo} />
          </HeadCell>
          <HeadCell className={classes.contextCell}>
            <Bone className={classes.bulkAction} />
          </HeadCell>
        </TableRow>
      </thead>
      <tbody>
        <SharedSkeletonEntry titleWidth={100} />
        <SharedSkeletonEntry titleWidth={60} />
        <SharedSkeletonEntry titleWidth={90} />
        <SharedSkeletonEntry titleWidth={70} />
      </tbody>
    </Table>
  </div>
)

export default injectSheet(styles)(SharedSkeleton)
